<template>
  <div class="page">
    <v-card class="pa-1 mt-12" max-width="500" elevation="0">
      <v-card-text>
        <v-form v-model="formValid" @submit.prevent="submitForm">
          <v-switch
            v-model="form.switch"
            label="Показать"
            color="primary"
            :true-value="1"
            :false-value="0"
          />

          <v-textarea
            v-model="form.message"
            label="Сообщение"
            required
            :rules="[(v) => !!v || 'Введите сообщение']"
          />

          <v-btn :disabled="!formValid || loading" type="submit" color="primary" class="mt-4">
            Сохранить
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script setup>
import { useStore } from 'vuex'
import { onMounted, ref } from 'vue'
import { useToast } from '@/composables/useToast'
import { api } from '@/api/Api'

const store = useStore()
const { toast } = useToast()

const form = ref({
  switch: 1,
  message: '',
})
const formValid = ref(false)
const loading = ref(false)

const setPageTitle = () => {
  store.commit('app/setPageTitle', 'Сервисное сообщение')
}

const submitForm = async () => {
  loading.value = true

  try {
    await api
      .user()
      .setServiceMessage(form.value)
      .then(() => {
        toast.success('Данные успешно сохранены')
      })
  } catch (err) {
    if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message)
    }
  } finally {
    loading.value = false
  }
}

const getMessage = async () => {
  await api
    .user()
    .getServiceMessage()
    .then((response) => {
      form.value = {
        ...response,
        switch: +response.switch,
      }
    })
}

onMounted(() => {
  setPageTitle()
  getMessage()
})
</script>
